import { useEffect, useState } from "react";
import { Printer, Sparkles } from "lucide-react";

export default function AppSplash({ onComplete }) {
  const [progress, setProgress] = useState(10);

  useEffect(() => {
    const p1 = setTimeout(() => setProgress(40), 300);
    const p2 = setTimeout(() => setProgress(75), 700);
    const p3 = setTimeout(() => setProgress(100), 1100);
    const done = setTimeout(() => {
      if (typeof onComplete === "function") {
        onComplete();
      }
    }, 1500);

    return () => {
      clearTimeout(p1);
      clearTimeout(p2);
      clearTimeout(p3);
      clearTimeout(done);
    };
  }, [onComplete]);

  return (
    <div
      className="fixed inset-0 z-50 bg-zinc-950 flex flex-col items-center justify-center p-6 text-white select-none overflow-hidden"
      data-testid="printq-splash-screen"
    >
      {/* Ambient background glow */}
      <div className="absolute -top-48 -left-48 w-[450px] h-[450px] rounded-full bg-amber-500/10 blur-[100px] pointer-events-none animate-pulse" />
      <div className="absolute -bottom-48 -right-48 w-[450px] h-[450px] rounded-full bg-emerald-500/10 blur-[100px] pointer-events-none animate-pulse" />

      <div className="relative flex flex-col items-center max-w-sm w-full gap-5">
        {/* Animated Brand Emblem */}
        <div className="relative group">
          <div className="absolute -inset-1 rounded-2xl bg-gradient-to-r from-amber-400 via-amber-500 to-emerald-500 opacity-70 blur-md transition duration-500 animate-pulse" />
          <div className="relative w-20 h-20 rounded-2xl bg-zinc-900 border border-zinc-800/80 flex items-center justify-center text-amber-400 shadow-2xl">
            <Printer className="w-10 h-10 stroke-[2]" />
          </div>
          <div className="absolute -bottom-1 -right-1 w-4 h-4 rounded-full bg-emerald-400 border-2 border-zinc-950" />
        </div>

        {/* Brand Titles */}
        <div className="text-center space-y-1">
          <div className="flex items-center justify-center gap-1.5">
            <span className="text-3xl font-black tracking-tight text-white">Print</span>
            <span className="text-3xl font-black tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-500">
              Q
            </span>
          </div>

          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-zinc-300">
            Scan. Enhance. Print.
          </p>

          <p className="text-[10px] font-medium tracking-[0.18em] uppercase text-zinc-500 pt-1">
            by JSM DIGITAL SOLUTIONS
          </p>
        </div>

        {/* Progress Bar & Status */}
        <div className="w-full flex flex-col gap-2 mt-4">
          <div className="w-full h-1.5 bg-zinc-900 rounded-full overflow-hidden border border-zinc-800">
            <div
              className="h-full bg-gradient-to-r from-amber-400 via-amber-500 to-emerald-500 rounded-full transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="flex items-center justify-between text-[11px] text-zinc-500">
            <span>Starting Scan & Print engine...</span>
            <span className="text-amber-400 font-mono font-bold">{progress}%</span>
          </div>
        </div>
      </div>
    </div>
  );
}